<style lang='scss'>
    .document-container {
        display: flex;
        background: #fff;
        margin-bottom: 10px;
    }
    .document-avatar {
        display: flex;
        margin-right: 10px;
        width:130px;
        height:130px;
        .image{
            background-repeat: no-repeat !important;
            background-position: center !important;
            -webkit-background-size: cover !important;
            -moz-background-size: cover !important;
            -o-background-size: cover !important;
            background-size: cover !important;
            width:230px;
            height: 130px;
            display: flex;
            align-items: center;
            align-content: center;
            justify-content: center;
        }
    }
    .document-content > b {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-size: 1em;
        line-height: 1.3em;
    }
    .document-content {
        width:100%;
        padding: 10px;
    }

    .section-label{
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-size: 0.9em;
        margin-top: 5px;
    }
    .test{
        .ivu-select-dropdown{
            top: 22px !important;
        }
    }
</style>

<template>
  <Row type="flex" :gutter="20" align="middle" style="padding-top:10px;">
    <i-col :span="24" v-for="(item, i) in userDocuments" :key="item.id"
    style="border-bottom: 1px solid #eee;">
        <Card shadow :style="{borderRadius: '0', marginBottom: '10px'}" :padding="0">
            <!-- <Dropdown @on-clickoutside="handleClose(i)" ref="documentRef" trigger="custom" :visible="showDropdown(i)" class="aw test" placement="bottom-end" style="float:right; padding-right:5px;">
                <div href="javascript:void(0)" @click="handleOpen(i)" style="height:56px;width:20px;padding:4px 0px; color: black;">
                    <Icon style="display: flex; justify-content: flex-end;" size="20" type="android-more-vertical"></Icon>
                </div>
                <DropdownMenu slot="list">
                    <DropdownItem>
                        <a @click="handleClose(i), deleteItem(item)">Delete</a>
                    </DropdownItem>
                    <DropdownItem>
                        <a @click="handleClose(i), updateItem(item)">Update</a>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown> -->                  
            
            <div style="" class="document-container" >
                <span v-if="item.cover_photo_uri " class="document-avatar">
                    <div @click="showVuerPlaylist($event,'imgViewerz',true,i)" class="image" :style="{background: 'url('+ postPreviewImage(item,'medium') +')'}"></div>
                    <img v-show="false" ref="imgViewerz" :src="postPreviewImage(item, 'original')" style="width:130px;height:130px;" />
                </span>
                <div v-on:click="viewActivity(item)" class="document-content">
                    <b>{{item.title}}</b>
                    <p class="section-label" v-html="contentDisplay(item)"></p>
                </div>
            </div>
        </Card>
    </i-col>
  </Row>
</template>

<script>
import WindowScrollEvent from 'vue-scroll-event/mixins/WindowOnScroll'
import VuerMixin from '@/helpers/vuerMixin'


import Utils from '@/utils.js'
export default {
  components:{},
  mixins: [WindowScrollEvent,VuerMixin],
    data(){
        return{
            showList:[],
            statusSelect: [
            {
                value: 'delete',
                label: 'delete'
            },
            {
                value: 'update',
                label: 'update'
            }
            ]
        }
    },
    methods:{
        init(){
            if(this.$refs.documentRef && this.showList.length == 0){
                for(var i=0;i<this.$refs.documentRef.length;i++){
                    this.showList.push({id:i,visible:false});
                }
            }
            this.$store.dispatch('user/getDocuments')
            .then(res =>{},error=>{})
        },
        showDropdown(v){
            return this.showList.length > 0 && this.showList[v] && this.showList[v].visible
        },
        handleOpen (v) {
            setTimeout(() => {
                this.showList[v].visible = true                        
            }, 300);
        },
        handleClose (v) {
            if(this.showList[v]){
                this.showList[v].visible = false
            }
        },            
        handleCloseAll (v) {
            if(this.$refs.documentRef){
                for(var i=0;i<this.$refs.documentRef.length;i++){
                    if(this.showList[i]){
                        this.showList[i].visible = false
                    }
                }
            }
        },
        onWindowScroll () {
            this.handleCloseAll();
        },
        postPreviewImage (act, size) {
            return Utils.getDisplayImage('activity', act, size)
        },
        contentDisplay (act) {            
            switch (act.type) {
                case 'document':
                    if (act.data) return act.data.notes                    
                    break
            }
        },
        viewActivity (item) {
            this.$router.push({ path: '/feed/' + item.id + "?scroll=false" , query:{isAdmin:true, isDocuments: true}})
        },
        confirmDelete(id) {
            this.$store.dispatch('user/deleteItem', id)
                .then(r => {
                for( let x=0;x<this.userDocuments.length; x++) {
                    if (this.userDocuments[x].id == id) {
                    this.userDocuments.splice(x, 1);
                    break;
                    }
                }
            })
        },
        deleteItem(item) {
            console.log('delete-item', item);
            this.$Message({
                closable: true,
                title: { content:'Delete Post' },
                icon: 'ios-trash',
                message: { content: 'Are you sure you want to delete this post?' },
                buttons: [
                { label: 'Yes', type: 'error', hideAfter:true, action: ()=> {
                        this.confirmDelete(item.id) 
                    }
                },
                { label: 'Cancel', type: 'primary', hideAfter:true, action: ()=> {} }
                ]
            });
        },
        updateItem(item){
            console.log('update-item', item);
        }
    },
    computed:{
        profileInfo: {
            get() {
                return this.$store.state.user.info;
            },
        },
        feed: {
            get () {
                return this.$store.state.resource.groupFeed
            }
        },
        userDocuments:{
            get(){
                return this.$store.state.user.documents.data.careplan_item
            }
        }
    },
    mounted(){
        this.init();
    }
}
</script>
